module.exports = __webpack_public_path__ + "img/ksbx.2daab824.png";